import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import {
	SetAcuityLenderBranches, SetCmpAcuityLenderBranches,
	SetLenders
} from '../state/actions/global-configuration.actions';

@Injectable()
export class DefaultSettingLoaderService implements CanActivate {
	constructor(private store: Store) {
	}

	/**
	 * Load all util lists for lender routes.
	 * @param childRoute
	 * @param state
	 */
	canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		// eslint-disable-next-line no-async-promise-executor
		return new Promise(async resolve => {
			await this.store.dispatch(new SetAcuityLenderBranches()).toPromise();
			await this.store.dispatch(new SetCmpAcuityLenderBranches()).toPromise();
			await this.store.dispatch(new SetLenders()).toPromise();
			return resolve(true);
		});
	}
}
